// eslint-disable-next-line import/prefer-default-export
export var SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';
//# sourceMappingURL=actionTypes.js.map